<template>
  <dialog :class="['modal', classes]" ref="modal">
    <slot name="modal-content"></slot>
  </dialog>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    classes: String,
    open: Boolean
  },

  watch: {
    open(value) {
      if (value === true) {
        this.$refs.modal.showModal();
      } else {
        this.$refs.modal.close();
      }
    }
  },

  methods: {}
}
</script>

<style scoped>
dialog {
  margin: auto;
  border-radius: 5px;
  border: none;
  background: transparent;
}

dialog::backdrop {
  background: rgba(0, 0, 0, 0.4);
}

dialog:focus-visible {
  outline: none;
}

</style>